import {
  TRAVEL_PREMIUMS,
  TRAVEL_PREMIUMS_SUCCESS,
  TRAVEL_PREMIUMS_ERROR,
  TRAVEL_PREMIUMS_CLEAR_DATA,
} from "./actionTypes";

export const travelPremiums = (body) => {
  return {
    type: TRAVEL_PREMIUMS,
    payload: { body },
  };
};

export const travelPremiumsSuccess = (success) => {
  return {
    type: TRAVEL_PREMIUMS_SUCCESS,
    payload: success,
  };
};

export const travelPremiumsError = (error) => {
  return {
    type: TRAVEL_PREMIUMS_ERROR,
    payload: error,
  };
};

export const travelPremiumsClearData = () => {
  return {
    type: TRAVEL_PREMIUMS_CLEAR_DATA,
    payload: {},
  };
};
